const dataManager = {
  "data-mgmt": {
    dialog: {
      node: {
        title: "Unit, Data Imputation and Application Display Settings",
        desc: "Set the unit of measure, unit name, data type, and display in the application for uploaded data items.\nAfter completing the settings, press the Save button.",
        next: "Setup",
      },
      discretize: {
        title: "Causal Inference Data Settings",
        desc: "Set the discretization level values first, and if manual, determine the values that bound each level.\nThe causal hierarchy setting only allows causation to the same layer and the layer with the highest number.\nAfter completing the settings, press the Save button.",
        next: "Setup",
      },
    },
  },

  // SHARED
  "data-mgmt-reload-api-success": "The data has been successfully refreshed.",
  "data-mgmt-reload-api-loading": "Refreshing the data...",
  "data-mgmt-reload-api-error": "Failed to refresh the data.",

  // MAIN
  "data-mgmt-main-title": "Data Manager",
  "data-mgmt-main-description":
    "On this page, you can manage your data-related settings and other information.",

  "data-mgmt-main-tab1": "ID Code",
  "data-mgmt-main-tab2": "Node",
  "data-mgmt-main-tab3": "Prior",
  "data-mgmt-main-tab4": "Group",

  "data-mgmt-main-button2": "Download CSV Checker",
  "data-mgmt-main-button3": "Data Upload",
  "data-mgmt-main-tooltip": "Lack of Authority",

  // SUMMARY
  "data-mgmt-summary-widget1-title": "Active Data Size",
  "data-mgmt-summary-widget2-title": "Active ID Code",
  "data-mgmt-summary-widget4-title": "Date Range",
  "data-mgmt-summary-widget5-title": "Uploaded At",

  // UPLOAD
  "data-mgmt-upload-dialog-title": "1. Data upload",
  "data-mgmt-upload-dialog-desc":
    "This section temporarily uploads selected data.",

  "data-mgmt-upload-dialog-tab1": "Add",
  "data-mgmt-upload-dialog-tab1-description":
    "Newly added to previously uploaded data.",
  "data-mgmt-upload-dialog-tab2": "New",
  "data-mgmt-upload-dialog-tab2-desc":
    "All previously uploaded data will be deleted.",

  "data-mgmt-upload-dialog-support1": "Drag & drop files or",
  "data-mgmt-upload-dialog-support2": "Browse",
  "data-mgmt-upload-dialog-support3": "Supported formats",

  "data-mgmt-upload-dialog-limit1": "File Limit",
  "data-mgmt-upload-dialog-limit2": "Size Limit",
  "data-mgmt-upload-dialog-submit1": "Upload File",
  "data-mgmt-upload-dialog-submit2": "Uploading...",

  "data-mgmt-upload-dialog-size-over": "Total available data size exceeded.",
  "data-mgmt-upload-dialog-size-alert": "Please be careful as the total data size is approaching the capacity limit.(",
  "data-mgmt-upload-dialog-size-alert2": " remaining)",

  "data-mgmt-upload-dialog-toast-error1": "File not selected.",
  "data-mgmt-upload-dialog-toast-error2": "Data upload failed.",
  
  "data-mgmt-upload-csv-checker-checkbox": "Upload CSV (output file) verified with CSV checker.",
  "data-mgmt-upload-csv-checker-note-1": "※ CSV checker can be downloaded from the",
  "data-mgmt-upload-csv-checker-note-2": "on the left of the upload button.",
  "data-mgmt-upload-csv-checker-label": "Use file verified with CSV checker",

  // SUBJECT ATTRIBUTE (step 2)
  "data-mgmt-attr-step-title": "2. Stratification attributes",
  "data-mgmt-attr-step-dialog-desc":
    "In this section, you select the columns used as stratification attributes.",
  "data-mgmt-attr-step-desc":
    "Select 2 attributes for stratification (text columns are selected automatically).",
  "data-mgmt-attr-step-type-integer": "Integer",
  "data-mgmt-attr-step-type-float": "Decimal",
  "data-mgmt-attr-step-type-string": "Text",
  "data-mgmt-attr-step-type-other": "Other",
  "data-mgmt-attr-step-distinct": "Distinct",
  "data-mgmt-attr-step-truncated": "(top values only)",
  "data-mgmt-attr-step-selected": "Selected attributes",
  "data-mgmt-attr-step-submit": "OK",
  "data-mgmt-attr-step-submitting": "Saving ...",
  "data-mgmt-attr-step-toast-error": "Failed to set the stratification attributes.",
  "data-mgmt-attr-step-too-few":
    "At least 2 candidate columns (integer / text) are required. Please re-upload the CSV.",
  "data-mgmt-attr-step-too-many-strings":
    "There are 3 or more text columns. Attributes are limited to 2, and all text columns must be designated as attributes. Please re-upload the CSV.",

  // Cancelling the ingest (aborting the upload). Shared by steps 2 and 3.
  "data-mgmt-ingest-cancel": "Cancel",
  "data-mgmt-ingest-cancelling": "Cancelling ...",
  "data-mgmt-ingest-cancel-toast-success": "The upload has been cancelled.",
  "data-mgmt-ingest-cancel-toast-error": "Failed to cancel the upload.",

  // TIME GRAIN (step 3)
  "data-mgmt-grain-step-title": "3. Time granularity",
  "data-mgmt-grain-step-dialog-desc":
    "In this section, you select the time granularities to generate.",
  "data-mgmt-grain-step-desc":
    "Select the time granularities to aggregate (multiple allowed). Granularities finer than the detected value cannot be selected.",
  "data-mgmt-grain-step-detected": "detected",
  "data-mgmt-grain-step-submit": "OK",
  "data-mgmt-grain-step-submitting": "Saving ...",
  "data-mgmt-grain-step-toast-error": "Failed to set the time granularity.",

  // 時間粒度の自動確定 (旧ステップ3 の置き換え)。フォールバックは無く、閉じると取込を中止する。
  "data-mgmt-grain-auto-error-title": "Failed to set the time granularity",
  "data-mgmt-grain-auto-error-close": "Close",
  "data-mgmt-grain-auto-error-no-enabled": "The vendor has no time granularity configured, so this additional ingest cannot continue.\nThe upload will be cancelled. Please contact your administrator.",
  "data-mgmt-grain-auto-error-no-finest": "Could not detect the finest time granularity from the uploaded data.\nThe upload will be cancelled. Please contact your administrator.",
  "data-mgmt-grain-auto-error-failed": "Failed to set the time granularity automatically.\nThe upload will be cancelled. Please try again later.",

  // Display names for time grain keys. Keep one entry per GRAIN_OPTIONS key.
  "data-mgmt-grain-key-nanosec": "Nanosecond",
  "data-mgmt-grain-key-microsec": "Microsecond",
  "data-mgmt-grain-key-millisec": "Millisecond",
  "data-mgmt-grain-key-sec": "Second",
  "data-mgmt-grain-key-min": "Minute",
  "data-mgmt-grain-key-hour": "Hour",
  "data-mgmt-grain-key-quarter_day": "Quarter day",
  "data-mgmt-grain-key-day": "Day",
  "data-mgmt-grain-key-week": "Week",
  "data-mgmt-grain-key-month": "Month",
  "data-mgmt-grain-key-quarter_year": "Quarter year",
  "data-mgmt-grain-key-year": "Year",


  // STORE
  "data-mgmt-store-dialog-title": "3. Activate uploaded data",
  "data-mgmt-store-dialog-title-legacy": "2. Activate uploaded data",
  "data-mgmt-store-dialog-desc":
    "In this section, you can choose to activate or deactivate the uploaded data.",

  "data-mgmt-store-dialog-widget1": "Data Size",
  "data-mgmt-store-dialog-widget1-error": "Data size limit exceeded.",
  "data-mgmt-store-dialog-widget2": "Active ID Code",
  "data-mgmt-store-dialog-widget2-error": "Active id code limit exceeded.",
  "data-mgmt-store-dialog-widget3": "File Limit",

  "data-mgmt-store-dialog-submit1": "Reject",
  "data-mgmt-store-dialog-submit2": "Rejecting ...",
  "data-mgmt-store-dialog-submit3": "Approve",
  "data-mgmt-store-dialog-submit4": "Approving ...",
  "data-mgmt-store-dialog-analyzing":
    "Analyzing the uploaded data. You can run the ingest once it completes.",

  "data-mgmt-store-dialog-toast-success1": "Added to queue.",
  "data-mgmt-store-dialog-toast-success2": "Data successfully activated.",
  "data-mgmt-store-dialog-toast-success3": "Data successfully deactivated.",
  "data-mgmt-store-dialog-toast-error1": "File not selected.",
  "data-mgmt-store-dialog-toast-error2": "Data approve failed.",
  "data-mgmt-store-dialog-toast-error3": "Data reject failed.",
  "data-mgmt-store-dialog-toast-error4":
    "The max number of files available for selection has been exceeded.",

  // NODE
  "data-mgmt-node-toolbar": "Node",
  "data-mgmt-node-discretize-toolbar": "Causal Inference Data Settings",

  "data-mgmt-node-widget-numbers": "Usage Numbers",
  "data-mgmt-node-widget-data-range": "Data Range",
  "data-mgmt-node-widget-uploaded-date": "Last Upload Date",
  "data-mgmt-node-widget-numbers-unit1": "IDs",
  "data-mgmt-node-widget-numbers-unit2": "Nodes",
  "data-mgmt-node-widget-numbers-unit3": "Records",
  "data-mgmt-node-widget-capacity": "利用量",

  "data-mgmt-node-toolbar-save": "Save",
  "data-mgmt-node-toolbar-saving": "Saving",

  "data-mgmt-node-table-col1": "Data Item",
  "data-mgmt-node-table-col2": "Unit",
  "data-mgmt-node-table-col3": "Decimal Places",
  "data-mgmt-node-table-col4": "Imputation Type",
  "data-mgmt-node-table-col6": "Updated at",

  "data-mgmt-node-save-api-success":
    "The node settings has been successfully updated.",
  "data-mgmt-node-save-api-error": "Failed to update the node settings.",

  // Error modal
  "data-mgmt-error-modal-title": "CSV File Processing Error",
  "data-mgmt-error-modal-file-label": "File:",
  "data-mgmt-error-modal-error-code-label": "Error Code:",
  "data-mgmt-unknown-error": "Unknown error",

  // ID CODE
  "data-mgmt-idcode-toolbar-export": "Export",
  "data-mgmt-idcode-toolbar-save": "Save",

  "data-mgmt-idcode-table-col1": "ID Code",
  "data-mgmt-idcode-table-col2": "Integration Code",
  "data-mgmt-idcode-table-col3": "Status",
  "data-mgmt-idcode-table-col4": "Group",

  "data-mgmt-idcode-save-api-success":
    "The id code has been successfully updated.",
  "data-mgmt-idcode-save-api-error": "Failed to update the id code.",

  "data-mgmt-idcode-api-success1": "The id code was deleted successfully.",
  "data-mgmt-idcode-api-success2": "The group was adapted successfully.",
  "data-mgmt-idcode-api-success3": "The id code was issued successfully.",

  "data-mgmt-idcode-export-success": "The id code was export successfully.",

  "data-mgmt-idcode-api-error1": "he id code was not deleted successfully.",
  "data-mgmt-idcode-api-error2": "The group was not adapted successfully.",
  "data-mgmt-idcode-api-error3": "Please complete the form.",
  "data-mgmt-idcode-api-error4": "The id code was not issued successfully.",

  "data-mgmt-idcode-export-error": "The id code was not export successfully.",

  // GROUP
  "data-mgmt-group-toolbar-add": "Add Group",

  "data-mgmt-group-table-col1": "Name",
  "data-mgmt-group-table-col2": "Description",

  "data-mgmt-group-api-success1": "The group was added successfully.",
  "data-mgmt-group-api-success2": "The group was deleted successfully",

  "data-mgmt-group-api-error1": "The group was not added successfully.",
  "data-mgmt-group-api-error2": "The group was not deleted successfully.",
  "data-mgmt-group-api-error3": "Please complete the form.",

  "data-mgmt-group-add-dialog-title": "Add Group",
  "data-mgmt-group-add-dialog-disc": "Click change when you're done.",
  "data-mgmt-group-add-dialog-item1": "Name",
  "data-mgmt-group-add-dialog-item2": "Discription",
  "data-mgmt-group-add-dialog-submit": "Add Group",

  "data-mgmt-group-delete-dialog-title": "Delete Group",
  "data-mgmt-group-delete-dialog-disc": "Click change when you're done.",
  "data-mgmt-group-delete-dialog-item1": "Name",
  "data-mgmt-group-delete-dialog-item2": "Discription",
  "data-mgmt-group-delete-dialog-submit": "Delete Group",

  // PRIOR
  "data-mgmt-prior-home-title": "Prior",

  "data-mgmt-prior-table-col1": "Name",
  "data-mgmt-prior-table-col2": "Description",
  "data-mgmt-prior-table-col3": "Status",
  "data-mgmt-prior-table-col4": "Prohibit",
  "data-mgmt-prior-table-col5": "Updated at",
  "data-mgmt-prior-table-col6": "Saved at",

  "data-mgmt-prior-api-loading": "Verifying prior settings.",
  "data-mgmt-prior-api-success-activate":
    "Prior activation completed successfully.",
  "data-mgmt-prior-api-success-deactivate":
    "Prior deactivation completed successfully.",
  "data-mgmt-prior-api-success-delete":
    "Prior deletion completed successfully.",
  "data-mgmt-prior-api-error": "Failed to apply prior settings.",

  // PRIOR - EXTRACT
  "data-mgmt-prior-extract-toolbar": "Causality Extraction",
  "data-mgmt-prior-extract-title": "Causality Extraction Result",
  "data-mgmt-prior-extract-consent-title": "Causal Candidate Selection",

  "data-mgmt-prior-extract-deleting": "Deleting",
  "data-mgmt-prior-extract-delete": "Delete",

  "data-mgmt-prior-extract-table-col1": "Source",
  "data-mgmt-prior-extract-table-col2": "Target",
  "data-mgmt-prior-extract-table-col3": "Section",
  "data-mgmt-prior-extract-table-col4": "Status",
  "data-mgmt-prior-extract-table-col5": "Description",
  "data-mgmt-prior-extract-table-col6": "Saved at",

  "data-mgmt-prior-extract-api-success":
    "Causality have been successfully deleted.",
  "data-mgmt-prior-extract-api-error": "Failed to delete causality.",

  "data-mgmt-prior-extract-concent-api-success":
    "Causality have been successfully saved.",
  "data-mgmt-prior-extract-concent-api-error": "Failed to save causality.",

  "data-mgmt-prior-extract-dialog-trigger": "Add Causal Candidate",
  "data-mgmt-prior-extract-dialog-title": "Search Similar Terms",

  "data-mgmt-prior-extract-dialog-field1-title": "Outcome",
  "data-mgmt-prior-extract-dialog-field1-button1": "Search",
  "data-mgmt-prior-extract-dialog-field1-button2": "Searching",

  "data-mgmt-prior-extract-dialog-field1-valid1": "This field is required.",
  "data-mgmt-prior-extract-dialog-field1-valid2":
    "Please enter within 64 characters.",
  "data-mgmt-prior-extract-dialog-field1-valid3":
    "Invalid characters are included.",

  "data-mgmt-prior-extract-dialog-api1-loading": "Searching for similar terms.",
  "data-mgmt-prior-extract-dialog-api1-success1":
    "Similar terms were successfully retrieved.",
  "data-mgmt-prior-extract-dialog-api1-success2":
    "No similar terms were found; please try changing the outcome name.",
  "data-mgmt-prior-extract-dialog-api1-error":
    "Failed to retrieve similar terms.",

  "data-mgmt-prior-extract-dialog-field2-title": "Similar Terms",

  "data-mgmt-prior-extract-dialog-api2-loading":
    "Fetching candidate causality.",
  "data-mgmt-prior-extract-dialog-api2-success1":
    "Candidate causality have been successfully retrieved.",
  "data-mgmt-prior-extract-dialog-api2-success2":
    "No candidate causality were found; please go back to the previous section and adjust your similar terms selection.",
  "data-mgmt-prior-extract-dialog-api2-error":
    "Failed to retrieve candidate causality.",

  "data-mgmt-prior-extract-dialog-submit": "Next",

  "data-mgmt-prior-extract-concent-saving": "Saving",
  "data-mgmt-prior-extract-concent-save": "Save",

  "data-mgmt-prior-extract-concent-empty-desc":
    "It is possible that all candidate edges have already been saved or there are no candidate causal relationships.",
  "data-mgmt-prior-extract-concent-empty-button": "Back",

  // PRIOR - ASSIGN
  "data-mgmt-prior-assign-toolbar": "Node Assignment",
  "data-mgmt-prior-assign-title": "Node Assignment",

  "data-mgmt-prior-assign-table-col1": "Source",
  "data-mgmt-prior-assign-table-col2": "Target",
  "data-mgmt-prior-assign-table-col3": "Prohibit",
  "data-mgmt-prior-assign-table-col4": "Description",

  "data-mgmt-prior-assign-api-success":
    "Node assignment completed successfully.",
  "data-mgmt-prior-assign-api-error": "Failed to assign nodes.",

  "data-mgmt-prior-assign-save": "Save",
  "data-mgmt-prior-assign-saving": "Saving",

  // PRIOR - SETTING
  "data-mgmt-prior-settings-toolbar": "Add Prior",
  "data-mgmt-prior-settings-title": "Prior Settings",

  "data-mgmt-prior-settings-table-col1": "Source",
  "data-mgmt-prior-settings-table-col2": "Target",
  "data-mgmt-prior-settings-table-col3": "Status",
  "data-mgmt-prior-settings-table-col4": "Description",

  "data-mgmt-prior-settings-discard": "Discard",
  "data-mgmt-prior-settings-discard-desc":
    "Discard settings and go to top page.",
  "data-mgmt-prior-settings-back": "Back",
  "data-mgmt-prior-settings-next": "Next",
  "data-mgmt-prior-settings-save": "Save",
  "data-mgmt-prior-settings-saving": "Saving",

  "data-mgmt-prior-settings-section1-title": "Title Setting",
  "data-mgmt-prior-settings-section1-field1-title": "Title",
  "data-mgmt-prior-settings-section1-field1-validate1":
    "This field is required.",
  "data-mgmt-prior-settings-section1-field1-validate2":
    "Please enter within 64 characters.",
  "data-mgmt-prior-settings-section1-field1-validate3":
    "Invalid characters are included.",
  "data-mgmt-prior-settings-section1-field2-title": "Description",
  "data-mgmt-prior-settings-section1-field2-validate1":
    "Please enter within 64 characters.",
  "data-mgmt-prior-settings-section1-field2-validate2":
    "Invalid characters are included.",

  "data-mgmt-prior-settings-section1-button1": "Discard",
  "data-mgmt-prior-settings-section1-button2": "Next",

  "data-mgmt-prior-settings-section2-title": "Select Causality",
  "data-mgmt-prior-settings-section2-button1": "Back",
  "data-mgmt-prior-settings-section2-button1-desc": "Go to previous section.",
  "data-mgmt-prior-settings-section2-button2": "Discard",
  "data-mgmt-prior-settings-section2-button3": "Next",

  "data-mgmt-prior-settings-section3-title": "Preview",

  "data-mgmt-prior-settings-section3-api-loading": "Saving prior settings.",
  "data-mgmt-prior-settings-section3-api-success":
    "prior settings have been saved successfully.",
  "data-mgmt-prior-settings-section3-api-error":
    "Failed to save prior settings.",

  "data-mgmt-prior-settings-section3-button1": "Back",
  "data-mgmt-prior-settings-section3-button1-desc": "Go to previous section.",
  "data-mgmt-prior-settings-section3-button2": "Discard",
  "data-mgmt-prior-settings-section3-button3-1": "Save",
  "data-mgmt-prior-settings-section3-button3-2": "Saving",

  "data-mgmt-prior-settings-notfound-desc":
    "Please assign node or add a new prior settings to complete the setup.",
  
  "data-mgmt-attr-select": "check",
  "data-mgmt-attr-item": "item",
  "data-mgmt-attr-unique": "unique",
  "data-mgmt-attr-type": "type",
  "data-mgmt-main-tab5": "Attributes",
  "data-mgmt-main-tab6": "Time grain",
  "data-mgmt-settings-attr-title": "Change stratification attributes",
  "data-mgmt-settings-attr-note": "Changing these rebuilds the stored data from the same source (a new version is created; the current data stays in use until it completes).",
  "data-mgmt-settings-attr-desc": "Select exactly 2 items to stratify by. String items are selected automatically.",
  "data-mgmt-settings-attr-submit": "Change and rebuild",
  "data-mgmt-settings-attr-toast-success": "Started rebuilding the data. This may take a while.",
  "data-mgmt-settings-grain-title": "Add time grain",
  "data-mgmt-settings-grain-note": "You can add grains to the current data. Removing generated grains and changing the finest grain are not supported (re-upload instead).",
  "data-mgmt-settings-grain-desc": "Check the grains to add. Grains that are already generated cannot be unchecked.",
  "data-mgmt-settings-grain-submit": "Add grains",
  "data-mgmt-settings-grain-toast-success": "Started adding the grains. This may take a while.",
  "data-mgmt-settings-grain-generating": "Generating",
  "data-mgmt-settings-grain-generating-note": "Generating the grains. The job keeps running even if you leave this page.",
  "data-mgmt-settings-grain-toast-done": "The grains have been added.",
  "data-mgmt-settings-grain-toast-failed": "Failed to generate the grains.",
  "data-mgmt-settings-grain-toast-timeout": "Generating the grains is taking a while. The job is still running, so please reopen this page later to check.",
  "data-mgmt-settings-agg-title": "Aggregation",
  "data-mgmt-settings-agg-desc": "Choose how each node is aggregated. The grains being added and the already generated grains are (re)built from the finest grain with the chosen method (the finest grain itself is not rebuilt). The chosen methods are saved and also used for later uploads.",
  "data-mgmt-settings-agg-col-name": "Node",
  "data-mgmt-settings-agg-col-method": "Aggregation",
  "data-mgmt-settings-agg-error": "Failed to load the nodes.",
  "data-mgmt-grain-agg-mean": "Mean",
  "data-mgmt-grain-agg-median": "Median",
  "data-mgmt-grain-agg-max": "Max",
  "data-mgmt-grain-agg-min": "Min",
  "data-mgmt-grain-agg-sum": "Sum",
  "data-mgmt-settings-no-data": "No data available to change. Import data first (data imported with the legacy flow cannot be changed).",

  // Setup guard (csv-storage-status)
  "setup-guard-title": "Setup is not complete",
  "setup-guard-failed-title": "Data import failed",
  "setup-guard-upload-body": "Please upload a CSV file",
  "setup-guard-upload-button": "Upload data",
  "setup-guard-processing-body": "Processing your data. Please wait",
  "setup-guard-canceled-body": "The data is deactivated. Please activate it",
  "setup-guard-canceled-button": "Go to Data Management",
  "setup-guard-imputation-body": "Please save the node settings in Data Management",
  "setup-guard-imputation-note": "Saving is required even without changes",
  "setup-guard-imputation-button": "Go to node settings",
  "setup-guard-discretization-body": "Please save the causal inference data settings in Data Management",
  "setup-guard-discretization-button": "Go to settings",
  "setup-guard-discretization-running-body": "Applying your settings. Please wait",
  "setup-guard-failed-imputation-body": "Failed to save the node settings",
  "setup-guard-failed-discretization-body": "Failed to save the causal inference data settings",
  "setup-guard-failed-store-body": "Failed to import the data. Please upload again",
  "setup-guard-failed-detail-button": "Show details",
  "setup-guard-failed-code-label": "Error code",
};

export default dataManager;
